import { render, staticRenderFns } from "./DepartmentMultipleSelection.vue?vue&type=template&id=8290e47a"
import script from "./DepartmentMultipleSelection.vue?vue&type=script&lang=js"
export * from "./DepartmentMultipleSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports